// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SortFilter__container___Ts1CE {
    display: flex;
    gap: var(--space-xs);
    width: 100%;
    margin-bottom: var(--space-l);
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Main/ProjectsView/SortFilter/SortFilter.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,oBAAoB;IACpB,WAAW;IACX,6BAA6B;AACjC","sourcesContent":[".container {\n    display: flex;\n    gap: var(--space-xs);\n    width: 100%;\n    margin-bottom: var(--space-l);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SortFilter__container___Ts1CE`
};
export default ___CSS_LOADER_EXPORT___;
